import BackDropComponent from "@/components/BackDrop";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button, Grid, Paper, Typography } from "@mui/material";
import React, { useRef, useState, useEffect } from "react";
import { updateB2BMisRequest } from "@/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { enqueueSnackbar } from "notistack";
const B2BMIS = () => {
    const [isBackOpenOpen, setIsBackOpenOpen] = useState(false);
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const dispatch = useDispatch();
    const updateB2BMisState = useSelector((state) => state.updateB2BMisReducer);
    /* ===================== FILE SELECT ===================== */
    const handleFileChange = (event) => {
        var _a;
        const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file)
            return;
        if (!file.name.endsWith(".xlsx")) {
            enqueueSnackbar("Only .xlsx files are allowed", { variant: "error" });
            return;
        }
        setSelectedFile(file);
        enqueueSnackbar("File selected successfully", { variant: "success" });
    };
    /* ===================== OPEN FILE PICKER ===================== */
    const handleUploadClick = () => {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    /* ===================== UPLOAD FILE ===================== */
    const handleSave = () => {
        const tenantId = localStorage.getItem("tenantId");
        if (!tenantId || !selectedFile) {
            enqueueSnackbar("File or Tenant ID missing", { variant: "error" });
            return;
        }
        const formData = new FormData();
        formData.append("tenantId", tenantId);
        formData.append("file", selectedFile);
        setIsBackOpenOpen(true);
        dispatch(updateB2BMisRequest(formData));
    };
    /* ===================== API RESPONSE ===================== */
    useEffect(() => {
        if (updateB2BMisState.data) {
            enqueueSnackbar("MIS uploaded successfully", { variant: "success" });
            setIsBackOpenOpen(false);
            setSelectedFile(null);
        }
        else if (updateB2BMisState.error) {
            enqueueSnackbar("Unable to upload MIS", { variant: "error" });
            setIsBackOpenOpen(false);
        }
    }, [updateB2BMisState]);
    return (React.createElement(Grid, { container: true, direction: "column", sx: { p: 4, minHeight: "calc(100vh - 66px)" }, className: "m_background_color" },
        React.createElement(Grid, { mb: 2 },
            React.createElement(Typography, { sx: { fontFamily: "Poppins", fontSize: 20, fontWeight: 600 } }, "B2B MIS")),
        React.createElement(Paper, { sx: { p: 3, borderRadius: 2, border: "1px solid #D2D1D6" } },
            React.createElement(Typography, { fontWeight: 600, mb: 2 }, "Update MIS"),
            React.createElement(Grid, { container: true, spacing: 2, alignItems: "center" },
                React.createElement(Grid, { item: true, xs: 9 },
                    React.createElement(Typography, { fontFamily: "Poppins", fontWeight: 500 }, "Upload final file")),
                React.createElement(Grid, { item: true, xs: 3 },
                    React.createElement(Button, { fullWidth: true, variant: "outlined", startIcon: React.createElement(CloudUploadIcon, null), onClick: handleUploadClick }, "Choose File"),
                    React.createElement("input", { ref: fileInputRef, type: "file", accept: ".xlsx", hidden: true, onChange: handleFileChange })),
                selectedFile && (React.createElement(Grid, { item: true, xs: 12, container: true, justifyContent: "flex-end" },
                    React.createElement(Typography, { fontSize: 14, fontWeight: 500 }, selectedFile.name))),
                React.createElement(Grid, { item: true, xs: 12, container: true, justifyContent: "flex-end" },
                    React.createElement(Grid, { item: true, xs: 2.9 },
                        React.createElement(Button, { fullWidth: true, variant: "contained", color: "error", disabled: !selectedFile, onClick: handleSave }, "Save"))))),
        React.createElement(BackDropComponent, { open: isBackOpenOpen })));
};
export default B2BMIS;
